<div style="background-color: #fff" *ngIf="currentUser" [ngStyle]="{'height': chatHeight}">
    <div *ngIf="!selectedChat" class="p-3" style="min-height:100vh;">
        <span class="montserrat text-center no-chat-text">
            {{'NO-HISTORY' | translate }}
        </span>
    </div>
    <div *ngIf="selectedChat" (resized)="onResized($event)">
        <!--History Header-->
        <div class="p-3 ml-1 chat-history-header">
            <ng-container *ngIf="isDirectChat(); else groupOrSpaceChatHeader">
                <div class="chat-history-header-row">
                    <div class="chat-history-header-avatar">
                        <div class="chat-history-header-avatar-wrap">
                            <img *ngIf="getDirectChatPeerPhotoUrl() as peerPhotoUrl" class="chat-history-header-avatar-img"
                                [src]="peerPhotoUrl" [attr.alt]="getDirectChatPeerDisplayName()" />
                            <span *ngIf="!getDirectChatPeerPhotoUrl() && getDirectChatPeerInitials() as peerInitials"
                                class="chat-history-header-avatar-initials" aria-hidden="true">{{ peerInitials }}</span>
                        </div>
                        <i *ngIf="isDirectChatPeerOnline()" class="fa fa-circle chat-online-badge"
                            [attr.title]="'ONLINE' | translate" aria-hidden="true"></i>
                    </div>
                    <span class="montserrat chat-history-title ellipsis-text">{{ getDirectChatPeerDisplayName() }}</span>
                </div>
            </ng-container>
            <ng-template #groupOrSpaceChatHeader>
                <div class="montserrat chat-history-title ellipsis-text" *ngIf="isGroupChat(); else spaceChatTitle">
                    <span *ngFor="let member of getGroupChatHeaderMembers(); let last = last"
                        class="chat-history-group-member">
                        <span>{{ member.firstName }}</span>
                        <i *ngIf="isUserOnline(member.userId)" class="fa fa-circle chat-online-icon"
                            [attr.title]="'ONLINE' | translate" aria-hidden="true"></i><span
                            *ngIf="!last" class="chat-history-group-separator">, </span>
                    </span>
                </div>
                <ng-template #spaceChatTitle>
                <div class="montserrat chat-history-title ellipsis-text">
                    {{selectedChat.text}}
                    <span class="ml-1" *ngIf="selectedChat?.chatSpace?.description" style="display: inline-flex">
                        <div kendoTooltip position="right" class="keyboard-accessible" tabindex="0" showOn="none"
                            (focus)="showTooltip(tooltipChat)" (mouseover)="showTooltip(tooltipChat)" (blur)="hideTooltip()"
                            (mouseout)="hideTooltip()" aria-live="polite">
                            <a #tooltipChat title="{{selectedChat?.chatSpace?.description}}">
                                <i class="fa fa-info-circle pointer"></i></a>
                        </div>
                    </span>
                </div>
                </ng-template>
                <div *ngIf="showChatMemberCount()" translate class="chat-members"
                    [translateParams]="{count: selectedChat.users.length}">{{ 'CHAT-MEMBERS' }}
                </div>
            </ng-template>
        </div>
        <!--History Chat-->
        <div #chatHistoryHost #chatEmojiTooltipHost class="chat-history-tooltip-host" kendoTooltip position="top" showOn="none"
            [showAfter]="100" [offset]="4" [callout]="true" tooltipClass="chat-history-emoji-kendo-tooltip"
            filter=".chat-history-emoji-anchor[title]"
            (mouseover)="onChatEmojiMouseOver($event)" (mouseout)="onChatEmojiMouseOut($event)">
            <div class="chat-history-load-older" *ngIf="historyLoadingOlder" role="status" aria-live="polite">
                <span class="chat-history-load-older-spinner" aria-hidden="true"></span>
                <span translate>CHAT-LOADING-OLDER</span>
            </div>
        <kendo-chat [messages]="chatHistory" [authorId]="currentUser.id"
            [messageContextMenuActions]="messageContextMenuActions"
            style="max-width:100%; margin:0 20px 20px 20px;"
            [ngStyle]="{'height': (windowHeight-165) + 'px'}">
            <!-- Bubble, then timestamp/actions, then reaction chips (see chat-history-message-meta). -->
            <ng-template kendoChatMessageContentTemplate let-message>
                <div class="chat-history-message-wrap chat-history-typing-wrap" *ngIf="isTypingIndicatorMessage(message)"
                    [attr.data-message-id]="message.id" role="status" aria-live="polite">
                    <div class="chat-history-typing-content">
                        <span class="chat-history-typing-text">
                            <span class="chat-history-typing-label" translate
                                [translateParams]="{ name: getTypingIndicatorDisplayName(message) }">{{ 'CHAT-TYPING-STATUS' }}</span>
                            <span class="chat-history-typing-dots" aria-hidden="true">
                                <span></span><span></span><span></span>
                            </span>
                        </span>
                    </div>
                </div>
                <div class="chat-history-message-wrap" *ngIf="!isTypingIndicatorMessage(message)" [attr.data-message-id]="message.id">
                    <div class="chat-history-message-bubble">
                        <button type="button" class="chat-history-reply-quote"
                            *ngIf="getMessageReplyToId(message) as replyToId"
                            [attr.title]="'CHAT-GO-TO-REPLY' | translate"
                            [attr.aria-label]="'CHAT-GO-TO-REPLY' | translate"
                            (click)="scrollToMessage(replyToId, $event)">
                            <ng-container *ngIf="hasReplyQuoteContent(message, replyToId); else replyUnavailable">
                                <span class="chat-history-reply-quote-heading">
                                    <span class="chat-history-reply-quote-label">{{ 'CHAT-QUOTE' | translate }}</span>
                                    <span class="chat-history-reply-quote-author">{{ getReplyQuoteAuthor(message, replyToId) }}</span>
                                </span>
                                <span class="chat-history-reply-quote-text">{{ getReplyQuotePreviewText(message, replyToId) }}</span>
                            </ng-container>
                            <ng-template #replyUnavailable>
                                <span class="chat-history-reply-quote-text">{{ 'CHAT-REPLY-UNAVAILABLE' | translate }}</span>
                            </ng-template>
                        </button>
                        <div class="chat-history-message-text">
                            <ng-container *ngFor="let part of getMessageParts(message); trackBy: trackMessagePart">
                                <ng-container *ngIf="part.type === 'text'">{{ part.value }}</ng-container>
                                <span *ngIf="part.type === 'emoji'" class="chat-history-emoji-anchor"
                                    [attr.title]="getEmojiLabel(part.emoji)"
                                    [attr.aria-label]="getEmojiLabel(part.emoji)">
                                    <img *ngIf="part.emoji.image" [src]="getEmojiImageUrl(part.emoji.image)"
                                        class="chat-custom-emoji" alt="" role="presentation" />
                                    <span *ngIf="!part.emoji.image" class="chat-history-emoji-char">{{ part.emoji.char }}</span>
                                </span>
                            </ng-container>
                        </div>
                    </div>
                    <div class="chat-history-message-meta">
                        <span class="chat-history-message-time">{{ getMessageTimestamp(message) }}</span>
                        <span *ngIf="message?.updated" class="chat-history-status-text">{{ textChatUpdated }}</span>
                        <span class="chat-history-reaction-wrap">
                            <button type="button" kendoButton fillMode="flat" themeColor="base"
                                class="chat-icon-action-btn chat-history-reaction-btn k-icon-button"
                                [attr.title]="'CHAT-ADD-REACTION' | translate"
                                [attr.aria-label]="'CHAT-ADD-REACTION' | translate"
                                (click)="openReactionPicker(message, $event); $event.stopPropagation()">
                                <i class="fal fa-smile" aria-hidden="true"></i>
                            </button>
                        </span>
                        <span class="chat-history-copy-wrap">
                            <button type="button" kendoButton fillMode="flat" themeColor="base"
                                class="chat-icon-action-btn chat-history-copy-btn k-icon-button"
                                [attr.title]="'CHAT-COPY-MESSAGE' | translate"
                                [attr.aria-label]="'CHAT-COPY-MESSAGE' | translate"
                                (click)="copyMessage(message, $event)">
                                <i class="fal fa-copy" aria-hidden="true"></i>
                            </button>
                        </span>
                        <span class="chat-history-reply-wrap">
                            <button type="button" kendoButton fillMode="flat" themeColor="base"
                                class="chat-icon-action-btn chat-history-reply-btn k-icon-button"
                                [attr.title]="'CHAT-REPLY' | translate"
                                [attr.aria-label]="'CHAT-REPLY' | translate"
                                (click)="startReply(message, $event)">
                                <i class="fal fa-reply" aria-hidden="true"></i>
                            </button>
                        </span>
                        <span *ngIf="canEditMessage(message)" class="chat-history-edit-wrap">
                            <button type="button" kendoButton fillMode="flat" themeColor="base"
                                class="chat-history-edit-btn k-icon-button"
                                [attr.title]="'CHAT-EDIT-MESSAGE' | translate"
                                [attr.aria-label]="'CHAT-EDIT-MESSAGE' | translate"
                                (click)="startEdit(message, $event)">
                                <i class="fal fa-edit" aria-hidden="true"></i>
                            </button>
                        </span>
                        <span *ngIf="isCurrentUser(message)" class="chat-history-delete-wrap">
                            <button type="button" kendoButton fillMode="flat" themeColor="base"
                                class="chat-icon-action-btn chat-history-delete-btn k-icon-button"
                                [attr.title]="'DELETE' | translate"
                                [attr.aria-label]="'DELETE' | translate"
                                (click)="deleteHistory(message, $event); $event.stopPropagation()">
                                <i class="fal fa-trash-alt" aria-hidden="true"></i>
                            </button>
                        </span>
                    </div>
                    <div class="chat-message-reactions" *ngIf="getReactionGroups(message).length > 0">
                        <button type="button" class="chat-reaction-chip"
                            *ngFor="let group of getReactionGroups(message); trackBy: trackReactionGroup"
                            [class.chat-reaction-chip-own]="group.includesCurrentUser"
                            [attr.title]="getReactionTooltip(group)"
                            [attr.aria-label]="getReactionTooltip(group)"
                            (click)="onReactionChipClick(message, group, $event)">
                            <img *ngIf="group.emoji?.image" [src]="getEmojiImageUrl(group.emoji.image)"
                                class="chat-reaction-emoji-img" alt="" role="presentation" />
                            <span *ngIf="group.emoji && !group.emoji.image" class="chat-reaction-emoji-char">{{ group.emoji.char }}</span>
                            <span *ngIf="!group.emoji" class="chat-reaction-emoji-fallback">{{ group.emojiKey }}</span>
                            <span class="chat-reaction-count">{{ group.count }}</span>
                        </button>
                    </div>
                </div>
            </ng-template>
            <!-- Kendo requires a status template when message.status is set; UI lives in chat-history-message-meta. -->
            <ng-template kendoChatStatusTemplate let-status>
                <span class="chat-history-status-slot" aria-hidden="true">{{ status }}</span>
            </ng-template>
            <ng-template kendoChatMessageBoxTemplate>
                <div class="m-1 chat-compose-box">
                    <div class="chat-compose-edit" *ngIf="editingMessage">
                        <button type="button" class="chat-compose-edit-dismiss chat-icon-action-btn"
                            [attr.title]="'CANCEL' | translate" [attr.aria-label]="'CANCEL' | translate"
                            (click)="cancelEdit()">
                            <i class="fal fa-times" aria-hidden="true"></i>
                        </button>
                        <button type="button" class="chat-compose-edit-body"
                            [attr.title]="'CHAT-GO-TO-REPLY' | translate"
                            (click)="scrollToMessage(editingMessage.id, $event)">
                            <span class="chat-compose-edit-heading">
                                <i class="fal fa-edit chat-compose-edit-icon" aria-hidden="true"></i>
                                <span class="chat-compose-edit-label">{{ 'CHAT-EDITING-MESSAGE' | translate }}</span>
                            </span>
                            <span class="chat-compose-edit-text">{{ getReplyPreviewText(editingMessage) }}</span>
                        </button>
                    </div>
                    <div class="chat-compose-reply" *ngIf="replyToMessage && !editingMessage">
                        <button type="button" class="chat-compose-reply-dismiss chat-icon-action-btn"
                            [attr.title]="'CANCEL' | translate" [attr.aria-label]="'CANCEL' | translate"
                            (click)="cancelReply()">
                            <i class="fal fa-times" aria-hidden="true"></i>
                        </button>
                        <button type="button" class="chat-compose-reply-body"
                            [attr.title]="'CHAT-GO-TO-REPLY' | translate"
                            (click)="scrollToMessage(getReplyTargetMessageId(replyToMessage), $event)">
                            <span class="chat-compose-reply-label" translate
                                [translateParams]="{ name: getMessageAuthorName(replyToMessage) }">
                                {{ 'CHAT-REPLYING-TO' }}
                            </span>
                            <span class="chat-compose-reply-text">{{ getReplyPreviewText(replyToMessage) }}</span>
                        </button>
                    </div>
                    <kendo-textarea (inputFocus)="onInputFocus()" (inputBlur)="onInputBlur()"
                        (valueChange)="onMessageBoxValueChange()"
                        placeholder="{{textMessage.replace('{{text}}', selectedChat.text)}}" resizable="none" [rows]="3"
                        (keydown)="onKeyDown($event)" #messageBoxInput class="ellipsis-text" maxlength="15000">
                        <kendo-textarea-suffix class="mb-2 chat-compose-suffix">
                            <span class="k-flex-1"></span>
                            <div class="chat-compose-actions">
                                <div class="chat-emoji-picker-wrap">
                                    <button #emojiPickerAnchor type="button" kendoButton fillMode="flat" themeColor="base"
                                        class="chat-icon-action-btn chat-emoji-toggle-btn k-icon-button"
                                        (click)="toggleEmojiPicker($event)"
                                        [attr.aria-expanded]="emojiPickerOpen"
                                        [attr.title]="'CHAT-ADD-EMOJI' | translate"
                                        [attr.aria-label]="'CHAT-ADD-EMOJI' | translate">
                                        <i class="fal fa-smile" aria-hidden="true"></i>
                                    </button>
                                </div>
                                <kendo-input-separator class="k-text-base"></kendo-input-separator>
                                <button kendoButton (click)="clearValue()" fillMode="flat" themeColor="base"
                                    class="chat-icon-action-btn chat-clear-btn k-icon-button"
                                    [attr.title]="'CLEAR' | translate"
                                    [attr.aria-label]="'CLEAR' | translate">
                                    <i class="fal fa-times" aria-hidden="true"></i>
                                </button>
                                <kendo-input-separator class="k-text-base"></kendo-input-separator>
                                <button kendoButton (click)="sendMessage()" fillMode="flat" themeColor="base"
                                    class="chat-icon-action-btn chat-send-btn k-icon-button"
                                    [attr.title]="(editingMessage ? 'CHAT-SAVE-EDIT' : 'SEND') | translate"
                                    [attr.aria-label]="(editingMessage ? 'CHAT-SAVE-EDIT' : 'SEND') | translate">
                                    <i class="fal fa-arrow-up" aria-hidden="true"></i>
                                </button>
                            </div>
                        </kendo-textarea-suffix>
                    </kendo-textarea>
                </div>
            </ng-template>
        </kendo-chat>
        </div>
    </div>
</div>

<!--Note deletion confirmation-->
<kendo-dialog title="{{ 'PLEASE-CONFIRM' | translate }}" *ngIf="deleteConfirmationOpened"
    (close)="onDeleteDialogClose()" [minWidth]="250" [width]="450">
    <p>{{ 'CHAT-CONFIRM-DELETION' | translate }}</p>
    <p>{{ deleteHistoryItem.text ?? deleteHistoryItem.content }}</p>
    <kendo-dialog-actions>
        <button kendoButton (click)="onDeleteDialogClose()">{{ 'NO' | translate }}</button>
        <button appPreventClick kendoButton (click)="onDelete();" [primary]="true">{{ 'YES' | translate }}</button>
    </kendo-dialog-actions>
</kendo-dialog>

<kendo-popup *ngIf="emojiPickerOpen && emojiPickerAnchorElement" [anchor]="emojiPickerAnchorElement"
    [anchorAlign]="emojiPickerAnchorAlign" [popupAlign]="emojiPickerPopupAlign" [margin]="emojiPopupMargin"
    popupClass="chat-emoji-popup">
    <div class="chat-emoji-picker" role="listbox" [attr.aria-label]="emojiPickerAriaLabel | translate">
        <div *ngIf="emojisLoading" class="chat-emoji-loading">{{ 'CHAT-EMOJIS-LOADING' | translate }}</div>
        <ng-container *ngIf="!emojisLoading">
            <div class="chat-emoji-search">
                <input #emojiSearchInput type="search" class="chat-emoji-search-input"
                    [value]="emojiSearchTerm" (input)="onEmojiSearchInput($event)"
                    (click)="$event.stopPropagation()" [attr.placeholder]="'CHAT-EMOJI-SEARCH' | translate"
                    [attr.aria-label]="'CHAT-EMOJI-SEARCH' | translate">
            </div>
            <div class="chat-emoji-picker-body">
                <div *ngIf="filteredEmojiCategories.length === 0 && (emojiSearchTerm.trim() || recentEmojis.length === 0)" class="chat-emoji-no-results">
                    {{ 'CHAT-EMOJIS-NO-RESULTS' | translate }}
                </div>
                <section class="chat-emoji-category chat-emoji-recent" *ngIf="!emojiSearchTerm.trim() && recentEmojis.length > 0">
                    <h4 class="chat-emoji-category-title">{{ 'CHAT-EMOJI-RECENT' | translate }}</h4>
                    <div class="chat-emoji-grid">
                        <ng-container *ngFor="let emoji of recentEmojis"
                            [ngTemplateOutlet]="emojiButton" [ngTemplateOutletContext]="{ emoji: emoji }">
                        </ng-container>
                    </div>
                </section>
                <section class="chat-emoji-category" *ngFor="let category of filteredEmojiCategories">
                    <h4 class="chat-emoji-category-title">{{ getEmojiCategoryKey(category.id) | translate }}</h4>
                    <div class="chat-emoji-grid">
                        <ng-container *ngFor="let emoji of category.emojis"
                            [ngTemplateOutlet]="emojiButton" [ngTemplateOutletContext]="{ emoji: emoji }">
                        </ng-container>
                    </div>
                </section>
            </div>
        </ng-container>
    </div>
</kendo-popup>

<ng-template #emojiButton let-emoji="emoji">
    <span class="chat-emoji-btn-tooltip" kendoTooltip position="top" showOn="hover" [showAfter]="100" [offset]="4"
        [callout]="true">
        <button type="button" class="chat-emoji-btn" (click)="selectEmoji(emoji, $event)"
            [attr.title]="getEmojiLabel(emoji)" [attr.aria-label]="getEmojiLabel(emoji)">
            <img *ngIf="emoji.image" [src]="getEmojiImageUrl(emoji.image)" class="chat-emoji-img" alt="" />
            <span *ngIf="!emoji.image">{{ emoji.char }}</span>
        </button>
    </span>
</ng-template>